export const CLUSTER_ALERTS_INTEVAL = 10000;
export const REFRESH_METRICS_INTERVAL = 30000;
export const REFRESH_LOGS_INTERVAL = 5000;
